import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=267922c2&scoped=true&"
import script from "./MessageTemplates.vue?vue&type=script&lang=js&"
export * from "./MessageTemplates.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplates.vue?vue&type=style&index=0&id=267922c2&prod&lang=scss&scoped=true&"
import style1 from "./MessageTemplates.vue?vue&type=style&index=1&id=267922c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267922c2",
  null
  
)

export default component.exports